import { useCallback, useState, createContext } from "react";
import SpinnerComponent from "../Components/Spinner/Spinner";
const LoadingContext = createContext();

export default LoadingContext;
export function LoadingContextProvider({ children }) {
    const [loading, setLoading] = useState(0);
    const addLoading = useCallback(
        function (loadingValue) {
            if (loadingValue) {
                setLoading((c) => c + 1);
            } else {
                setLoading((c) => Math.max(0, c - 1));
            }
        },
        [setLoading]
    );

    return (
        <LoadingContext.Provider value={addLoading}>
            {children}
            <SpinnerComponent showLoading={loading > 0}></SpinnerComponent>
        </LoadingContext.Provider>
    );
}
